import { render, staticRenderFns } from "./RelevancyReport.vue?vue&type=template&id=559f2fa5&scoped=true"
import script from "./RelevancyReport.vue?vue&type=script&lang=js"
export * from "./RelevancyReport.vue?vue&type=script&lang=js"
import style0 from "./RelevancyReport.vue?vue&type=style&index=0&id=559f2fa5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f2fa5",
  null
  
)

export default component.exports